import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { merge, of } from 'rxjs';
// import { push } from 'connected-react-router';

import { UPDATE_WATCH_LIST_ENTRY_EU_TERRORISTS } from '../types';
import { updateWatchListEntryFulfilled, updateWatchListEntryPending, updateWatchListEntryRejected } from '../actions';
import { sendApiRequest } from '../../../actions/apiRequestActions';
import { notifySuccess, notifyError } from '../../../actions';
import { WATCH_LIST_ENTRY_MESSAGES } from '../constants/watchListEntryMessages';
// import routesConfig from '../../../routes/routes-config';
import generateError from '../../../utilities/generateError';

const createPayload = payload => ({
  method: 'put',
  url: 'watchlistentryeuterrorists/update',
  onSuccess: [
    updateWatchListEntryFulfilled,
    () => notifySuccess(WATCH_LIST_ENTRY_MESSAGES.UPDATED),
    // () => push(routesConfig.watchListEntriesPage.path), // TODO maybe change the location
  ],
  onError: [
    updateWatchListEntryRejected,
    error => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: 'ajaxApi',
};

const updateWatchListEntryEpic$ = action$ => action$.pipe(
  ofType(UPDATE_WATCH_LIST_ENTRY_EU_TERRORISTS.DEFAULT),
  mergeMap(({ payload }) => merge(
    of(updateWatchListEntryPending()),
    of(sendApiRequest(createPayload(payload), meta)),
  )),
);

export default updateWatchListEntryEpic$;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry-eu-terrorists/epics/updateWatchListEntryEpic.js